import { useState, useCallback } from "react";
import { getGroupReportFilterOptions, getSingleGroupReport } from "../../service/AdminService/groupService.js";
import { showSuccessMessage,showErrorMessage } from "../../components/shared/pagination/messages.js";
const DEFAULT_FILTER_OPTIONS = {
  groupDetails: null,
  courseNames: [],
  bundleNames: [],
};

export const useGroupReport = () => {
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterOptions, setFilterOptions] = useState(DEFAULT_FILTER_OPTIONS);
  const [filterOptionsLoading, setFilterOptionsLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchFilterOptions = useCallback(async (groupId) => {
    setFilterOptionsLoading(true);
    try {
      const response = await getGroupReportFilterOptions(groupId);
      if (response?.status === "SUCCESS") {
        setFilterOptions({
          groupDetails: response.data.groupDetails || null,
          courseNames: response.data.courseNames || [],
          bundleNames: response.data.bundleNames || [],
        });
        return response.data;
      }
    } catch (err) {
      showErrorMessage("Failed to load filter options.");
      console.error("[useGroupReport] fetchFilterOptions error:", err);
    } finally {
      setFilterOptionsLoading(false);
    }
    return null;
  }, []);


  const fetchReport = useCallback(async (groupId, params = {}) => {
    setLoading(true);
    try {
      const response = await getSingleGroupReport(groupId, params);
      if (response?.status === "SUCCESS") {
        setData(response.data?.content || []);
        setTotalRecords(response.data?.totalRecords || 0);
        return response;
      }
    } catch (err) {
      showErrorMessage("Failed to load report data.");
      console.error("[useGroupReport] fetchReport error:", err);
    } finally {
      setLoading(false);
    }
    return null;
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setTotalRecords(0);
  }, []);

  return {
    data,
    totalRecords,
    filterOptions,
    loading,
    filterOptionsLoading,
    fetchFilterOptions,
    fetchReport,
    reset,
  };
};